import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { trackPageview } from './umami';

// Fires a pageview on every react-router navigation. Lives inside the
// <BrowserRouter> so the hook has router context.
export function useRouteTracking() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);
}

export function RouteTracker() {
  useRouteTracking();
  return null;
}
